import { defineStore } from 'pinia';
import { useModalStore } from './modal-store';

export const useErrorStore = defineStore('error', {
    state: () => ({
        general: false,
        cvBox: false,
        cvLoadingError: false,
        motivationLetters: false,
        lauraHeidelbeereException: false,
    }),
    getters: {
        hasCvLoadingError: state => state.cvLoadingError,
    },
    actions: {
        setCvError() {
            const modals = useModalStore();
            modals.$patch({
                error: {
                    show: true,
                    text: `
              Leider gibt es aktuell ein Problem beim Erstellen deines Lebenslauf-PDFs.
              Lade bitte deinen eigenen Lebenslauf als Dokument hoch, um
              deine Bewerbung abzuschließen.
              `,
                },
            });
            this.cvBox = true;
            this.cvLoadingError = true;
        },
    },
});
